import React, { useRef } from 'react';
var VeltCommentBubbleAvatar = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-bubble-avatar", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentBubbleAvatar;
